<template>
  <div class="page-404-error">
    <div class="error-logo">
      <div class="number">4</div>
      <img src="@/assets/images/element/lemon.svg" alt="Yuzu lemon" class="lemon" />
      <div class="number">4</div>
    </div>
    <div class="block-content">
      <div class="error-small">{{ $t("other.errorPages.404.title") }}</div>
      <h1>{{ $t("other.errorPages.404.subtitle") }}</h1>
      <p>
        {{ $t("other.errorPages.404.text") }}
      </p>
    </div>
    <Button class="primary" :label="$t('other.errorPages.404.buttons.back')" @click="$router.push('/')" />
  </div>
</template>
